var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81906 6.39524L3.57409 4.6402C3.66878 4.53923 3.72046 4.40538 3.71822 4.26698C3.71597 4.12858 3.65996 3.99649 3.56205 3.89864C3.46414 3.8008 3.332 3.74489 3.1936 3.74274C3.0552 3.74059 2.92139 3.79237 2.82049 3.88713L0.155686 6.55193C0.0813039 6.62647 0.030673 6.72139 0.0101845 6.82468C-0.0103041 6.92798 0.000268236 7.03503 0.0405668 7.13232C0.0671929 7.19706 0.106311 7.25592 0.155686 7.30553L2.82049 9.97034C2.92101 10.0674 3.05563 10.1211 3.19537 10.1199C3.33511 10.1187 3.46879 10.0627 3.5676 9.96384C3.66642 9.86503 3.72247 9.73135 3.72368 9.59161C3.7249 9.45187 3.67118 9.31725 3.57409 9.21673L1.81906 7.46116H4.79671V6.39524H1.81906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79675 1.59888V6.39552H10.6593C10.8007 6.39552 10.9362 6.45168 11.0362 6.55162C11.1361 6.65157 11.1923 6.78713 11.1923 6.92848C11.1923 7.06983 11.1361 7.20539 11.0362 7.30534C10.9362 7.40529 10.8007 7.46144 10.6593 7.46144H4.79675V12.2581C4.79675 12.6821 4.96521 13.0888 5.26505 13.3887C5.5649 13.6885 5.97158 13.857 6.39563 13.857H13.3241C13.7482 13.857 14.1549 13.6885 14.4547 13.3887C14.7545 13.0888 14.923 12.6821 14.923 12.2581V1.59888C14.923 1.17483 14.7545 0.76815 14.4547 0.468301C14.1549 0.168453 13.7482 0 13.3241 0H6.39563C5.97158 0 5.5649 0.168453 5.26505 0.468301C4.96521 0.76815 4.79675 1.17483 4.79675 1.59888Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.1b206416a01c8d133e0a751ca4b91fac.svg";
export { ForwardRef as ReactComponent };